import React, { useMemo } from 'react';

import { useSharePanelStore } from 'src/common/store/share.store';
import { useFormikContext } from 'formik';
import { ShareLinkFormType } from '../../link-config-form.factory';
import { CDN_URL } from 'src/editor/content-creation/components/image-block';
import classNames from 'classnames';

export const ShareThumbnailImage = () => {
  const { uploadedFile, selectedImageUrl } = useSharePanelStore((state) => ({
    uploadedFile: state.uploadedThumbnailFile,
    selectedImageUrl: state.selectedImageUrl,
  }));

  const {
    values: { thumbnail_url: thumbnailUrl },
  } = useFormikContext<ShareLinkFormType>();

  const imageUrl = useMemo(() => {
    const uploadedFileUrl = uploadedFile ? URL.createObjectURL(uploadedFile) : null;
    return uploadedFileUrl || selectedImageUrl;
  }, [selectedImageUrl, uploadedFile]);

  const imageSrc = imageUrl || thumbnailUrl;

  if (!imageSrc) {
    return null;
  }

  const isThumbnailFromJourneyAsset = imageSrc.startsWith(CDN_URL);

  return (
    <img
      src={imageSrc}
      alt=''
      className={classNames('h-[175px] w-full rounded-lg', {
        'object-cover': !isThumbnailFromJourneyAsset,
        'object-contain': isThumbnailFromJourneyAsset,
      })}
    />
  );
};
